module.exports = __webpack_public_path__ + "img/lan2.49de2041.png";